import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { api } from 'constants/constant';
import { getHeaders } from 'auth/auth';

export const toolsApi = createApi({
  reducerPath: 'toolsApi',
  baseQuery: fetchBaseQuery({ baseUrl: api, credentials: 'include' }),
  endpoints: (builder) => ({
    getLoanLimit: builder.mutation({
      query: (body) => ({
        url: 'b2b/tools/loan_limit',
        method: 'POST',
        body,
        headers: getHeaders(),
      }),
    }),
  }),
});

export const { useGetLoanLimitMutation } = toolsApi;
